module.exports = __webpack_public_path__ + "static/media/air.34b887ab.png";